import {
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: i18n.t('scope.text_678'),
      }),
      {
        field: 'type',
        title: i18n.t('scope.text_679'),
        minWidth: 120,
        formatter: ({ cellValue }) => {
          const obj = {
            pay_bill: i18n.t('scope.text_681'),
            revoke_bill: i18n.t('scope.text_690'),
          }
          return obj[cellValue]
        },
      },
      {
        field: 'is_income',
        title: i18n.t('scope.text_687'),
        minWidth: 120,
        formatter: ({ row }) => {
          return row.is_income ? i18n.t('scope.text_688') : i18n.t('scope.text_689')
        },
      },
      {
        field: 'amount',
        title: i18n.t('scope.text_471'),
        minWidth: 120,
        slots: {
          default: ({ row }, h) => {
            return [
              <div style={{ color: row.is_income ? '#3f8600' : '#cf1322' }}>
                <a-icon type={ row.is_income ? 'arrow-up' : 'arrow-down' } />
                <span>{numerify(row.amount, '0,0.00')}</span>
              </div>,
            ]
          },
        },
      },
      {
        field: 'balance',
        title: i18n.t('scope.text_691'),
        minWidth: 70,
        formatter: ({ cellValue }) => {
          return numerify(cellValue, '0,0.00')
        },
      },
      {
        title: i18n.t('scope.text_512'),
        field: 'notes',
      },
    ]
  },
}
